import ApiService from "@services/api.service";
import { Notify } from 'quasar'

export const sessionCalendrierAlternance = {
  state: {
    periodes: [],
    periode: null,
  },
  mutations: {
    setPeriodes(state, periodes){
      state.periodes = periodes;
    },
    setPeriode (state, periode)
    {
      state.periode = periode;
    },
    addPeriodeToList(state, periode) {
      state.periodes.push(periode);
    },
    removePeriodeFromList(state, id) {
      state.periodes = state.periodes.filter(p => p.id !== id);
    },
  },
  actions: {
    async fetchPeriodesAlternance(context, { sessionType, sessionIri }) {
      try {
        const filterKey = sessionType === 'diplome' ? 'diplomeSession' : 'actionSession'
        const response = await ApiService.getRequest(
          `session_calendrier_alternances?${filterKey}=${sessionIri}&etat=0`
        )
        const periodes = response.data['hydra:member'] ?? []
        context.commit('setPeriodes', periodes)
        return periodes
      } catch (e) {
        console.error(e);
        Notify.create({
          message: "Impossible de récupérer les périodes",
          color: 'red'
        })
      }
    },

    async addPeriodeAlternance(context, periode){
      try{
        const response = await ApiService.postRequest('session_calendrier_alternances', periode)
        context.commit('setPeriode', response.data);
        context.commit('addPeriodeToList', response.data);
        Notify.create({
          message: "Période enregistrée avec succès",
          color: 'green'
        })
        return response.data;
      }catch(e){
        console.error(e);
        Notify.create({
          message: "Une erreur s'est produite",
          color: 'red'
        })
        throw e;
      }
    },

    async deletePeriodeAlternance(context, id) {
      try {
        await ApiService.patchRequest(`session_calendrier_alternances/${id}`, { etat: 1 })
        context.commit('removePeriodeFromList', id)
        Notify.create({
          message: "Période supprimée avec succès",
          color: 'green'
        })
      } catch (e) {
        console.error(e);
        Notify.create({
          message: "Une erreur s'est produite lors de la suppression",
          color: 'red'
        })
        throw e;
      }
    },
  },
  getters: {
    getPeriodes(state){
      return state.periodes;
    },
    getPeriode(state){
      return state.periode;
    },
  }
}
